import { render, staticRenderFns } from "./drewtheo.vue?vue&type=template&id=3daa0447&"
import script from "./drewtheo.vue?vue&type=script&lang=js&"
export * from "./drewtheo.vue?vue&type=script&lang=js&"
import style0 from "./drewtheo.vue?vue&type=style&index=0&media=screen&lang=scss&"


/* normalize component */
import normalizer from "!../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports